module.exports = __webpack_public_path__ + "img/material-cancel.80d5dfe9.svg";